/*  MUI  */
import { Groups } from '@mui/icons-material';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const CommunityIcon = () => {
    const { t } = useTranslation();

    return (
        <DarkTooltip arrow title={t('Common.community_note')}>
            <Groups fontSize="large" sx={{ color: 'notes.icon.community' }} />
        </DarkTooltip>
    );
};
